<template>
    <b-row class="products-item-wrap" :id="$parent.getId(product.name)" align-v="center">
        <b-col cols="12" md="6" class="products-item-content">
            <h3 class="products-item-title">{{product.name}}</h3>
            <p>{{product.desc}}</p>
            <ul>
                <li 
                    v-for="(item, index) in product.items" 
                    :key="index"
                >
                    <router-link 
                        :to="item.to"
                        class="products-item-link"
                    >
                        ● {{item.name}}
                    </router-link>
                </li>
            </ul>
        </b-col>
        <b-col cols="12" md="6"  class="products-item-img">
            <b-img :src="product.src" fluid></b-img>
        </b-col>
    </b-row>
</template>

<script>

export default {
    props: ['product']    
}
</script>

<style lang="scss">
    .products-item{
        &-wrap {
            flex-direction: column;
            padding: 20px;
            border: 1px solid $color-main;
            border-radius: 5px;

            &:not(:last-child){
                margin-bottom: 20px
            }
        }
        &-content{
            padding: 0px 20px;
            order: 2
        }
        &-img{
            order: 1
        }
        &-title{
            color: $color-main
        }
        &-link{
            display: block;
            padding:3px 0;
            color: $color-main;
            transition: all 0.3s;

            &:hover{
                padding-left: 10px
            }
        }
    }

    @media (min-width: 768px) {
        .products-item{
            &-wrap {
                flex-direction: row;
            }
            &-content{
                order: 1
            }
            &-img{
                order: 2
            }
        }
    }
</style>